import { minus, plus } from '@wordpress/icons';
import { ui } from '@wp-g2/styles';
import { clamp, noop } from 'lodash';
import React, { useCallback, useEffect, useRef } from 'react';
import { HStack } from '../HStack';
import { Icon } from '../Icon';
import { View } from '../View';
import * as styles from './TextInput.styles';
/**
 * @typedef Props
 * @property {import('./useTextInputState').TextInputState} __store
 * @property {boolean} disabled
 * @property {(int: number) => void} decrement
 * @property {(int: number) => void} increment
 */

/**
 *
 * @param {Props} props
 * @param {import('react').Ref<any>} forwardedRef
 */

function TextInputSteppers(props, forwardedRef) {
  var decrement = props.decrement,
      disabled = props.disabled,
      dragHandlersRef = props.dragHandlersRef,
      increment = props.increment;
  var dragHandlers = dragHandlersRef.current;
  return /*#__PURE__*/React.createElement(View, {
    className: styles.SpinnerWrapper
  }, /*#__PURE__*/React.createElement(HStack, Object.assign({}, dragHandlers, {
    className: styles.Steppers,
    expanded: true,
    spacing: 0
  }, ui.$('TextInputArrows'), {
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(UpDownArrows, {
    disabled: disabled,
    onDecrement: decrement,
    onIncrement: increment
  })));
}
/**
 *
 * @param {object} props
 * @param {boolean} props.disabled
 * @param {(event?: import('react').KeyboardEvent) => void} props.onIncrement
 * @param {(event?: import('react').KeyboardEvent) => void} props.onDecrement
 */


var _UpDownArrows = function (_ref) {
  var disabled = _ref.disabled,
      _ref$onIncrement = _ref.onIncrement,
      onIncrement = _ref$onIncrement === void 0 ? noop : _ref$onIncrement,
      _ref$onDecrement = _ref.onDecrement,
      onDecrement = _ref$onDecrement === void 0 ? noop : _ref$onDecrement;

  /** @type {import('react').MutableRefObject<number | undefined>} */
  var timeoutRef = useRef();
  var timeoutDurationStart = 500;
  var timeoutDurationEnd = 20;
  var timeoutDurationRef = useRef(timeoutDurationStart);
  var handleOnClearTimers = useCallback(function () {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutDurationRef.current = timeoutDurationStart;
  }, []);
  var handleOnMouseDownIncrement = useCallback(function (event) {
    if (event) {
      event.preventDefault();
    }

    timeoutRef.current = setTimeout(function () {
      onIncrement();
      timeoutDurationRef.current = clamp(timeoutDurationRef.current / 2, timeoutDurationEnd, timeoutDurationStart);
      handleOnMouseDownIncrement();
    }, timeoutDurationRef.current);
  }, [onIncrement]);
  var handleOnMouseDownDecrement = useCallback(function (event) {
    if (event) {
      event.preventDefault();
    }

    timeoutRef.current = setTimeout(function () {
      onDecrement();
      timeoutDurationRef.current = clamp(timeoutDurationRef.current / 2, timeoutDurationEnd, timeoutDurationStart);
      handleOnMouseDownDecrement();
    }, timeoutDurationRef.current);
  }, [onDecrement]);
  var handleOnIncrement = useCallback(function (event) {
    event.stopPropagation();
    onIncrement();
  }, [onIncrement]);
  var handleOnDecrement = useCallback(function (event) {
    event.stopPropagation();
    onDecrement();
  }, [onDecrement]);
  useEffect(function () {
    return function () {
      return handleOnClearTimers();
    };
  }, [handleOnClearTimers]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, Object.assign({
    as: "button",
    className: styles.SteppersUp,
    disabled: disabled,
    onClick: handleOnIncrement,
    onMouseDown: handleOnMouseDownIncrement,
    onMouseLeave: handleOnClearTimers,
    onMouseUp: handleOnClearTimers
  }, ui.$('TextInputStepperUp'), {
    height: "calc(100% - 4px)",
    icon: plus,
    size: 12,
    width: 20
  })), /*#__PURE__*/React.createElement(Icon, Object.assign({
    as: "button",
    className: styles.SteppersDown,
    disabled: disabled,
    onClick: handleOnDecrement,
    onMouseDown: handleOnMouseDownDecrement,
    onMouseLeave: handleOnClearTimers,
    onMouseUp: handleOnClearTimers
  }, ui.$('TextInputStepperDown'), {
    height: "calc(100% - 4px)",
    icon: minus,
    size: 12,
    width: 20
  })));
};

var UpDownArrows = /*#__PURE__*/React.memo(_UpDownArrows);
export default /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(TextInputSteppers));